export function anchor() {
  const anchor = document.querySelector('.js-anchor');
  const anchor_bottom = anchor.getBoundingClientRect().bottom + window.pageYOffset;
  
  window.addEventListener('scroll', () => {
    if(window.scrollY > anchor_bottom) {
      anchor.classList.add('is-sticky');
    } else {
      anchor.classList.remove('is-sticky');
    }
  })
}